export default {
  nomeErrors () {
    const errors = []
    if (!this.$v.item.name.$dirty) return errors
    !this.$v.item.name.required && errors.push('Nome obrigatório!')
    return errors
  },
}